
import {
    Row, Col,
} from 'reactstrap';

 import Widget from '../../components/Widget';

import React, { useState, useEffect } from "react";

import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    ResponsiveContainer,
} from "recharts";

const ConsultantsBySectional = () => {
    const [data, setData] = useState([]);
    const [ isLoading, setIsLoading ] = useState(true);
    const seccional = ['ARMENIA',
        'BARRANQUILLA',
        'BOGOTA NORTE',
        'BOGOTA SUR',
        'BUCARAMANGA',
        'CALI',
        'CARTAGENA',
        'CUCUTA',
        'IBAGUE',
        'MANIZALES',
        'MEDELLIN',
        'MONTERIA',
        'NEIVA',
        'PASTO',
        'PEREIRA',
        'SANTA MARTA',
        'TUNJA',
        'VALLEDUPAR',
        'VILLAVICENCIO'
    ];
    // The URL to the API endpoint
    const API_URL = "/consultant";

    // fetch the data
    useEffect(() => {
        fetch("/consultants")
            .then((response) => response.json())
            .then((data) => {
                setData(data)
            });
    }, []);
    useEffect(() => {

        var consultant = "";
        var subdata = [];
        fetch(API_URL)
            .then((res) => res.json())
            .then((data1) => {
                    data1.map(item => {
                    if(consultant === ""){
                        consultant = item.ejecutivo;
                    }
                    // mismo ejecutivo
                    if(consultant === item.ejecutivo) {
                        subdata.push("\"" + item.seccional + "\"" + ":" + item.counter);
                    }else if(consultant !== item.ejecutivo){
                        //diferente ejecutivo
                        var stringData = "{\"ejecutivo\":\""+consultant+"\", \"seccionales\":{"+subdata;

                        seccional.map(itemSeccional =>{
                           if(!stringData.includes(itemSeccional)){
                               stringData = stringData +",\""+ itemSeccional +"\":0";
                           }
                        });

                        stringData = stringData+"}}";
                        data.push(JSON.parse(stringData));
                        consultant = item.ejecutivo;
                        subdata = [];
                        subdata.push("\"" + item.seccional + "\"" + ":" + item.counter);

                    }
                });
                console.log(data);
                setData(data);
                setIsLoading(false);
            });
    }, []);
    return (
        <div>
            {/*<Heading text={`All books by topics`}/>*/}
            {
                isLoading
                    ? (<h3>Loading...</h3>)
                    : (
                        <div>
                            <Widget>
                                <Row>
                                    <Col lg="12" xs="100%">
                        <ResponsiveContainer width="100%" height={300}>
                            <BarChart data={data}  margin={{top: 5, right: 30, left: 20, bottom: 5}}>
                                <CartesianGrid />
                                {/*<XAxis type= "category" dataKey="ejecutivo"/>*/}
                                <XAxis dataKey="ejecutivo" angle={-90}></XAxis>
                                <YAxis></YAxis>
                                {/*<YAxis dataKey="ciudad"/>*/}
                                <Tooltip />
                                {/*<Legend />*/}
                                {/*<Bar datakey=""/>*/}
                                {/*<Bar datakey="N/A" stackId ="a" fill="#8884d8" />*/}

                                <Bar dataKey="seccionales.ARMENIA" stackId ="a" fill="#000080" />
                                <Bar dataKey="seccionales.BARRANCABERMEJA" stackId ="a" fill="#0000FF" />
                                <Bar dataKey="seccionales.BOGOTA NORTE" stackId ="a" fill="#008000" />
                                <Bar dataKey="seccionales.BOGOTA SUR" stackId ="a" fill="#008080" />
                                <Bar dataKey="seccionales.BUCARAMANGA" stackId ="a" fill="#0080FF" />
                                <Bar dataKey="seccionales.CALI" stackId ="a" fill="#00FF00" />
                                <Bar dataKey="seccionales.CARTAGENA" stackId ="a" fill="#00FFFF" />
                                <Bar dataKey="seccionales.CUCUTA" stackId ="a" fill="#800000" />
                                <Bar dataKey="seccionales.GIRARDOT" stackId ="a" fill="#800080" />
                                <Bar dataKey="seccionales.IBAGUE" stackId ="a" fill="#8000FF" />
                                <Bar dataKey="seccionales.MANIZALES" stackId ="a" fill="#808000" />
                                <Bar dataKey="seccionales.MEDELLIN" stackId ="a" fill="#808080" />
                                <Bar dataKey="seccionales.MONTERIA" stackId ="a" fill="#8080FF" />
                                <Bar dataKey="seccionales.NEIVA" stackId ="a" fill="#FF0000" />
                                <Bar dataKey="seccionales.PASTO" stackId ="a" fill="#FF0080" />
                                <Bar dataKey="seccionales.PEREIRA" stackId ="a" fill="#FF00FF" />
                                <Bar dataKey="seccionales.POPAYAN" stackId ="a" fill="#FF8000" />
                                <Bar dataKey="seccionales.SANTA MARTA" stackId ="a" fill="#FF8080" />
                                <Bar dataKey="seccionales.SINCELEJO" stackId ="a" fill="#FF80FF" />
                                <Bar dataKey="seccionales.TUNJA" stackId ="a" fill="#FFFF00" />
                                <Bar dataKey="seccionales.VALLEDUPA" stackId ="a" fill="#000080" />
                                <Bar dataKey="seccionales.VILLAVICENCIO" stackId ="a" fill="#0000FF" />

                            </BarChart>
                        </ResponsiveContainer>
                                    </Col>
                                    <Col lg="12" xs="100%">

                                    </Col>
                                </Row>
                            </Widget>
                        </div>
                    )
            }
        </div>
    );
};

export default ConsultantsBySectional;